import { SNOWFLAKES_AMOUNT_BY_DATE } from '../config';

export const isShowCatchGame = () => {
  const daysToShowCatchGameLink = [8, 9, 14, 15, 19, 20];
  const monthsToShowCatchGame = [3];
  const yearsToShowCatchGame = [2025];
  // const daysToShowCatchGameLinkOnDev = Array.from({ length: 31 }).map((...args) => args[1] + 1);

  const currentDate = new Date();
  const currentDay = currentDate.getUTCDate();
  const currentMonth = currentDate.getUTCMonth();
  const currentYear = currentDate.getUTCFullYear();

  // Если для дева нужно, чтобы игра отображалась всегда, то надо раскомментить это условие
  // if (isProductionEnv) {
  return (
    Boolean(daysToShowCatchGameLink.includes(currentDay)) &&
    Boolean(monthsToShowCatchGame.includes(currentMonth)) &&
    Boolean(yearsToShowCatchGame.includes(currentYear))
  );
  // } else {
  //   return Boolean(daysToShowCatchGameLinkOnDev.includes(currentDay));
  // }
};

export const getSnowFlakessAmount = () => {
  const currentDate = new Date();
  const currentDay = currentDate.getUTCDate();

  const snowFlakesAmount = SNOWFLAKES_AMOUNT_BY_DATE[currentDay];

  return snowFlakesAmount || 0;
};

export const excludedPages = ['game/', 'welcome-bonus', '404', 'account', 'landing', 'chick-hunt'];
